import { useRef, useState } from 'react';
import GetIcon from '../../../utils/Icon';

const MultiFileInput = ({ name, setFile,error  }) => {
  const inputRef = useRef(null);
  const [fileList, setFileList] = useState([]);
  const [focused, setFocused] = useState(false);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const prefix = name.toLowerCase().replace(/[^a-z0-9]/gi, '_');

    const renamedFiles = files.map(file => {
      const ext = file.name.split('.').pop();
      const randomStr = Math.random().toString(36).substring(2, 6);
      const newName = `${prefix}_${randomStr}.${ext}`;
      return new File([file], newName, { type: file.type });
    });

    const updated = [...fileList, ...renamedFiles];
    setFileList(updated);
    setFile(updated);
  };

  const triggerFileInput = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const removeFile = (index) => {
    const updatedList = [...fileList];
    updatedList.splice(index, 1);
    setFileList(updatedList);
    setFile(updatedList);
  };

  return (
    <div className="custom-date-wrapper position-relative" style={{ height: '30px' }}>
      <label
        className={`custom-date-label ${focused || fileList.length ? 'active-tab' : ''}`}
        htmlFor={name}
        style={{ zIndex: 2, fontSize: '10px' }}
      >
        {name}
      </label>

      <div className={` rounded px-1 ${error ? 'errorborder' : 'border'}`} style={{ position: 'relative', height: '30px', overflow: 'hidden' }}>
        <div className="flex flex-wrap items-center gap-1" style={{ height: '100%' }}>
          {fileList.map((file, index) => (
            <span
              key={index}
              className="flex items-center"
              style={{
                background: '#EDEDED',
                color: '#5E6366',
                borderRadius: '12px',
                padding: '0 6px',
                fontSize: '8px',
                height: '18px',
                lineHeight: '18px',
              }}
            >
              {file.name}
              <button
                type="button"
                onClick={() => removeFile(index)}
                className="ml-1"
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '10px',
                  marginLeft: '6px',
                  cursor: 'pointer',
                  color: '#333',
                }}
              >
                ×
              </button>
            </span>
          ))}
        </div>

        <button
          type="button"
          className="btn btn-sm btn-primary"
          onClick={triggerFileInput}
          style={{
            position: 'absolute',
            right: '4px',
            top: '4px',
            height: '20px',
             width: '100px',
            padding: '0 6px',
            fontSize: '10px',
            background: 'linear-gradient(90deg, #391F84 0%, #FF8D5C 100%)',
            border: 'none',
          }}
        >
          <GetIcon iconName="MdOutlineFileUpload" size={12} /> Upload
        </button>

        <input
          type="file"
          ref={inputRef}
          onChange={handleFileChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          multiple
          accept="image/*"
          style={{ display: 'none' }}
        />
      </div>
    </div>
  );
};

export default MultiFileInput;
